import { render, staticRenderFns } from "./HeaderMobileBoxGroup.vue?vue&type=template&id=3b9556e0&"
import script from "./HeaderMobileBoxGroup.vue?vue&type=script&lang=js&"
export * from "./HeaderMobileBoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports